import React, { useTransition } from 'react';
import { Link as RouterLink, LinkProps, useNavigate } from 'react-router-dom';

export const TransitionLink: React.FC<LinkProps> = props => {
  // 我们只使用 startTransition 来包装导航。
  // isPending 状态被有意忽略，以实现零 UI 变化的过渡。
  const [, startTransition] = useTransition();
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // 阻止默认的链接行为
    e.preventDefault();

    // 开始一个非阻塞的过渡到新路由
    startTransition(() => {
      navigate(props.to);
    });
  };

  // 渲染一个标准的路由链接，但覆盖其点击行为。
  // 所有其他 props 都被传递下去，以保持样式和可访问性。
  return <RouterLink {...props} onClick={handleClick} />;
};
